<script setup lang="ts">

import {usePage} from "@inertiajs/vue3";
import {PagePropsInterface} from "@interfaces/PagePropsInterface.js";
import {computed, Ref} from "vue";
import {DiscountInterface} from "@interfaces/DiscountInterface.js";
import { trans } from 'laravel-vue-i18n'

let page = usePage<PagePropsInterface>();

let discount: Ref<DiscountInterface> = computed(() => {
    return page.props.discount;
});

let getText = computed((): string => {
    if(discount.value.description && discount.value.description.length > 0) {
        return discount.value.description;
    }

    return (discount.value.type === 'amount' ? '€' : '') +
        discount.value.discount + (discount.value.type === 'percentage' ? '%' : '') +
        ' \n' +
        trans('sections.discount_banner') +
        '<strong> ' + trans('sections.discount_until') + ' ' + new Date(discount.value.till).toLocaleDateString('en-GB') + '</strong>';
});

</script>
<template>
    <section id="layouts-section-discount-banner">
        <p
            v-html="getText"
            class="container">
        </p>
    </section>
</template>
<style lang="scss">
@use "@scss/layouts/sections/discount-banner";
</style>
